import { Children, cloneElement } from 'react';
import moment from 'moment';

const CURRENT_DATE = moment();

// Date cell wrapper for conditional background coloring
export const ColoredDateCellWrapper = ({ children, value }) => {
    let backgroundColor = 'white';

    if (CURRENT_DATE.isAfter(moment(value), 'day')) {
        backgroundColor = '#DDD';
    } else if (CURRENT_DATE.isSame(moment(value), 'day')) {
        backgroundColor = '#c0e1fa';
    }

    return cloneElement(Children.only(children), {
        style: {
            ...children.style,
            backgroundColor,
        },
    });
};